<template lang="pug">
    div.main-container(:style="{backgroundSize:'cover', backgroundImage:'url(' + require('@/assets/img2/insigne-bg-stroke-grey.png') + ')'} ")
        div.overlay
        
        div.main-content(id="content")
            div.layout-px-spacing
                div.page-header
                    div.page-title
                        h3 {{ $t('mycertificates.mycertificates') }}
                    
                       
                    
                    div
                        nav.breadcrumb-one(aria-label="breadcrumb")
                            ol.breadcrumb
                                li.breadcrumb-item
                                    router-link(to="/student/studenthome") {{ $t('mycertificates.studentdashboard') }}
                                li.breadcrumb-item.active(aria-current="page") {{ $t('mycertificates.mycertificates') }}

                div.row.mt-5.pb-5
                    div.col-lg-12.col-md-12.layout-spacing
                        div.statbox.widget.box.box-shadow
                            div.widget-header
                                div.row
                                    div.col-xl-12.col-md-12.col-sm-12.col-12.text-center
                                        h4
                                            template {{ $t('mycertificates.certificatesavailable') }}

                                div.widget-content.widget-content-area
                                    div.table-responsive
                                        table.table.table-bordered.table-hover.mb-4
                                            thead
                                                tr
                                                    th {{ $t('mycertificates.test') }}
                                                    th {{ $t('mycertificates.score') }}
                                                    th {{ $t('mycertificates.certificate') }}
                                           
                                            tbody
                                                tr(v-for="exam in examsList")
                                                    td {{ exam.sExamName }}
                                                    td {{ exam.iScore }}
                                                    td.text-center
                                                        a(href="" v-if="exam.sResult != ''" @click="GetCertificate(exam.idPersonExam, exam.idGroupDetail)")
                                                            svg.bi.bi-patch-check(xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16")
                                                                path(fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z")
                                                                path(d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z")

</template>

<script>
/* eslint-disable */
export default {
    name: 'MyCertificates',
    components: {
    },
    data() {
        return {
            examsList: [],
        }
    },
    methods: {
        async getMyExams() {
            await axios.get(apiURL + 'Student/getUserExams?idPerson='+ localStorage.CertIdP, { headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.userToken
            } })
            .then( (response) => {
                console.log(JSON.stringify(response.data.resultList))
                this.examsList = response.data.resultList.filter(function(exam) {
                    return exam.sResult == 'Aprobado' || exam.sResult == 'Passed'
                })
            } )
            .catch( (error)  => {
                console.log("error")
            } )
            
        },
        async GetCertificate(pIdPersonExam, pIdGroupDetail) {
            if(pIdGroupDetail == null)
            {
                pIdGroupDetail = 0
            }

            if(pIdPersonExam == null)
            {
                pIdPersonExam = 0
            }
            const routess = this.$router.resolve({
                name: 'Certificate',
                params: {idPersonExam: pIdPersonExam, idGroupDetail: pIdGroupDetail},   
            });
            window.open(routess.href, '_blank');
            //await axios.get(apiURL + 'Student/getCertificate?idPersonExam='+ idPersonExam + "&idGroupDetail=" + idGroupDetail, { headers: {
            //    'Content-Type': 'application/json',
            //    Authorization: 'Bearer ' + localStorage.userToken
            //} })
            //.then( (response) => {
            //    if(response.data.sErrors.length > 0)
            //    {
            //        Swal.fire({
            //            icon: 'error',
            //            title: 'Error',
            //            text: response.data.sErrors[0],
            //            footer: ''
            //        })
            //        return
            //    }


            //  let pdfWindow = window.open("")
            //    pdfWindow.document.write("<embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(response.data.base64Report)+"' type='application/pdf'></embed>")
                
                //window.open("data:application/pdf;base64," + atob(response.data.base64Report));
                //console.log(atob(response.data.base64Report))

                //this.examsList = response.data.resultList
            //} )
            //.catch( (error)  => {
            //    console.log("error")
            //} )            

        },


    },
    mounted() {
        this.checkPermisions(this.$router.currentRoute.path)
        this.getMyExams()

    }
        

}
</script>                                                              